var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpStrategy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_269_5942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5039 35.7463C21.0603 35.7463 24.7539 32.0527 24.7539 27.4963C24.7539 22.94 21.0603 19.2463 16.5039 19.2463C11.9476 19.2463 8.25391 22.94 8.25391 27.4963C8.25391 32.0527 11.9476 35.7463 16.5039 35.7463Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5033 43.0796C25.1097 43.0796 32.0866 36.1027 32.0866 27.4963C32.0866 18.8899 25.1097 11.913 16.5033 11.913C7.89682 11.913 0.919922 18.8899 0.919922 27.4963C0.919922 36.1027 7.89682 43.0796 16.5033 43.0796Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.919922 43.0797L5.48492 38.5146",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5234 38.5146L32.0866 43.0797",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1158 13.8838L29.4668 6.75396L35.3005 0.920288L37.2456 6.75396L43.0793 8.69912L37.2456 14.5328L30.1158 13.8838Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8372 9.16296L16.5039 27.4963",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_269_5942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpStrategy);
export default __webpack_public_path__ + "static/media/exp_strategy.96dd45c93039cc9da4e8bf8ca67fdb54.svg";
export { ForwardRef as ReactComponent };